<style lang="scss">
</style>

<script script lang="ts">
  import { Route, Router } from 'svelte-navigator'
  import Footer from '../components/Footer.svelte'
  import Header from '../components/Header.svelte'
  import { Constants } from '../config/constants'
  import { Slugs } from '../config/slugs'
  import {
    resultSetMenusRoutes,
    retrieveCommonWebsiteData
  } from '../controllers/AppController'
  import { listProjects } from '../controllers/ProjectsController'
  import { isMenuOpen, lang, projects, routes } from '../stores/stores'
  import About from './About.svelte'
  import CookiesPolicy from './CookiesPolicy.svelte'
  import DigitalGrow from './DigitalGrow.svelte'
  import Donation from './Donation.svelte'
  import Error404 from './Error404.svelte'
  import I_D from './I_D.svelte'
  import Maintenance from './Maintenance.svelte'
  import News from './News.svelte'
  import NewIndividualDetails from './New_Individual_Details.svelte'
  import PrivacyPolicy from './PrivacyPolicy.svelte'
  import Projects from './Projects.svelte'
  import SiteMap from './Site_Map.svelte'
  import Newsletter from './Newsletter.svelte'
  import MediaQuery from '../components/MediaQuery.svelte'
  import { ScreenSizes } from '../config/screen_sizes'

  export let name: string
  const isProd = process.env.isProd
  let isMaintenance = false
  let isLoaded = false

  $: void listProjects($lang)
    .then(resultSetMenusRoutes)
    .then(() => (isLoaded = true))
  $: retrieveCommonWebsiteData($lang)

  function routeSplit(r: string) {
    let s: string = r.split(Constants.DOUBLE_BARS, 2)[1]
    return s
  }

  function getRouteValueForNewDetails(r: string): string | undefined {
    let replacedStr = r.replace(Slugs.Show_News, Slugs.News)
    let routeValue = $routes.get(replacedStr)
    return routeValue
  }
</script>

<svelte:head>
  <title>{name}</title>
  {#if !isProd}
    <meta name="robots" content="noindex nofollow" />
  {/if}
</svelte:head>
{#if isLoaded}
  <MediaQuery query="(max-width: {ScreenSizes.MD_MAX_WIDTH}px)" let:matches>
    <div
      class="main-container px-0 min-vh-100 d-flex flex-column"
      class:main-menu-open={$isMenuOpen && matches}
    >
      {#if isMaintenance}
        <Maintenance />
      {:else}
        <Router>
          <Header lang={$lang} />
          <div class="bg-white flex-grow-1 main-content-container">
            <Route path="/" component={About} />
            {#each [...$projects] as p}
              {#if p.project_link?.translations}
                {#each p.project_link.translations as pl}
                  <Route path={pl.link}>
                    <Projects {p} />
                  </Route>
                {/each}
              {/if}
            {/each}
            {#each [...$routes.keys()] as r}
              {#if routeSplit(r) === Slugs.About || routeSplit(r) === Slugs.Lang || routeSplit(r) === Slugs.Homepage}
                <Route path={$routes.get(r)} component={About} />
              {/if}
              {#if routeSplit(r) === Slugs.News}
                <Route path="{$routes.get(r)}/:pageNumber" component={News} />
                <Route path={$routes.get(r)} component={News} />
              {/if}
              {#if routeSplit(r) === Slugs.Show_News}
                <Route
                  path="{getRouteValueForNewDetails(r)}/{$routes.get(r)}/:id"
                  component={NewIndividualDetails}
                />
              {/if}
              {#if routeSplit(r) === Slugs.Digital_Grow}
                <Route path={$routes.get(r)} component={DigitalGrow} />
              {/if}
              {#if routeSplit(r) === Slugs.Donation}
                <Route path={$routes.get(r)} component={Donation} />
              {/if}
              {#if routeSplit(r) === Slugs.I_D}
                <Route path={$routes.get(r)} component={I_D} />
              {/if}
              {#if routeSplit(r) === Slugs.COOKIE_POLICY}
                <Route path={$routes.get(r)} component={CookiesPolicy} />
              {/if}
              {#if routeSplit(r) === Slugs.PRIVACY_POLICY}
                <Route path={$routes.get(r)} component={PrivacyPolicy} />
              {/if}
              {#if routeSplit(r) === Slugs.SITE_MAP}
                <Route path={$routes.get(r)} component={SiteMap} />
              {/if}
              {#if routeSplit(r) === Slugs.Newsletter}
                <Route path={$routes.get(r)} component={Newsletter} />
              {/if}
            {/each}
            <Route component={Error404} />
          </div>
        </Router>
        <header />
        <Footer />
      {/if}
    </div>
  </MediaQuery>
{/if}
